import { Card, Loader } from 'cdk-radial';
import styled from 'styled-components';

export const StyledPageContentHeader = styled.div`
  padding: 15px;
  display: flex;
  justify-content: space-between;
`;
export const StyledLoader = styled(Loader)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledCard = styled(Card)`
  display: flex;
  padding-bottom: 0;
  box-shadow: none;
`;
